import script from "./CoursesMgmt.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoursesMgmt.vue?vue&type=script&setup=true&lang=ts"

import "./CoursesMgmt.vue?vue&type=style&index=0&id=f0336f82&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0336f82"]])

export default __exports__